// 项目所需所有的请求地址
export const loginUrls = {
    // 登录接口
    login: {
        url: '/feather/login',
    },
    captcha: {
      url: '/feather/captcha?rdm=' + new Date().getTime()
    },
    // 退出接口
    logout: '/feather/logout',
    // app下载
    appDowload: {
        // 获取app下载信息接口
        getAppDownLoadInfo: '/feather/apk/getAppDownLoadInfo'
    },
    // 查询用户信息
    queryUserInfo: {
        url: '/feather/user/getUserDetail',
    },
    // 查询一级目录
    queryOneMenu: '/feather/permission/getOneMenu',
    // 查询子级目录
    queryChilMenu: '/feather/permission/getTwoMenu',
    // 获取图片信息
    downloadFile_icon: '/file/files/downloadFile_icon',

    homePageUrls: {
        // 新增主页面配置
        save: '/feather/homepage/save',
        // 查询主页面配置
        getHomePageInfo: '/feather/homepage/getHomePageInfo'
    },
    loginUrls: {
        // 新增修改登录页面配置
        save: '/feather/login/save',
        // 查询登录页面配置信息
        getSchoolInfo: '/feather/getSchoolInfo',
    }
};
